import {Tariflist} from './module/tariflist';
import {Articlelist} from './module/articlelist';
import {OfferBoxer} from './module/offerBoxer';

import {Dsllist} from './module/dsllist';
import {Angebotslist} from './module/angebotslist';

import {Vvl} from './module/vvl';
import {ReloadManager} from './reloadManager';

export class CmsmoduleInit {
    private readonly reloadManager: ReloadManager;
    constructor(viewRoot: HTMLElement) {
        this.reloadManager = new ReloadManager();
        this.initCmsModule(viewRoot);
        this.registerEventListenersForFields(viewRoot);
        this.resetFilterListeners(viewRoot);
        this.showMoreListener(viewRoot);
        this.submitListeners(viewRoot);
    }
    private initCmsModule(viewRoot: HTMLElement) {
        new Tariflist(viewRoot);
        new Dsllist(viewRoot);
        new Articlelist(viewRoot);
        new OfferBoxer(viewRoot);
        new Angebotslist(viewRoot);
        new Vvl(viewRoot);
    }

    // fuer die artikelliste https://www.logitel.de/handys.html
    // und fuer die tarifliste https://www.logitel.de/tarife.html
    // und fuer die internetliste https://www.logitel.de/internet.html
    // haben wir jeweils drei formulare (sortieren, filter und mehr laden)
    // diese Daten muessen immer synchron sein (also wenn ein filter ausgewaehlt ist, soll dieser noch da sein, wenn wir sortieren)
    // daher werden die daten aller formulare an reloadModule weiter gegeben
    // nur fuer die sortieren funktion
    private submitListeners(viewRoot: HTMLElement): void {
        // Alle relevanten Formulare innerhalb von viewRoot finden
        const submitForms = viewRoot.querySelectorAll<HTMLFormElement>(
            'form.form_moduleCms_articlelist, form.form_moduleCms_tariflist, form.dsl-filter, form.form_moduleCms_tvtariflist',
        );

        submitForms.forEach((element: HTMLFormElement) => {
            element.addEventListener('submit', (event: SubmitEvent) => {
                event.preventDefault();
                const forms = viewRoot.querySelectorAll<HTMLFormElement>(
                    '.form_moduleCms_articlelist, .form_moduleCms_tariflist, form.dsl-filter, form.form_moduleCms_tvtariflist',
                );

                const serializedData: {name: string; value: FormDataEntryValue}[] = [];

                forms.forEach((formElement) => {
                    const formData = new FormData(formElement);
                    formData.forEach((value, key) => {
                        serializedData.push({name: key, value});
                    });
                });

                // Aktuelle Formular-Daten hinzufuegen
                const formData = new FormData(element);
                formData.forEach((value, key) => {
                    serializedData.push({name: key, value});
                });

                this.reloadManager.reloadModule(element, true, false, serializedData);
            });
        });
    }

    /**
     * pagination, naechste seite laden
     */
    private showMoreListener(viewRoot: HTMLElement): void {
        const showMoreItems = viewRoot.querySelectorAll<HTMLAnchorElement>('.showMoreItems');
        showMoreItems.forEach((element: HTMLAnchorElement) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();

                const form = element.closest('form') as HTMLFormElement;
                if (!form) {
                    return;
                }
                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const pageInputs = cmsRoot.querySelectorAll<HTMLInputElement>('input[name="page"]');
                if (pageInputs.length === 0) {
                    return;
                }

                pageInputs.forEach((pageInput) => {
                    const currentPage = parseInt(pageInput.value, 10);
                    if (!isNaN(currentPage)) {
                        pageInput.value = (currentPage + 1).toString();
                    }
                });

                this.reloadManager.reloadModule(form, true, true);
            });
        });
    }

    /**
     *  zum zuruecksetzen ALLER Filter
     */
    private resetFilterListeners(viewRoot: HTMLElement): void {
        const resetButtons = viewRoot.querySelectorAll<HTMLElement>('.clearFilter');
        resetButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                let form = element.closest('form') as HTMLFormElement | null;
                if (!form) {
                    // wenn der reset button nicht in einem formular liegt, gehe zu module-root und schaue in dem modul nach einem form
                    const cmsRoot = element.closest('.cms-module-root');
                    form = cmsRoot ? cmsRoot.querySelector('form') : null;
                }
                if (!form) {
                    return;
                }

                // Setze alle Eingabefelder im Formular zurueck
                form.querySelectorAll<HTMLInputElement>('input').forEach((input) => {
                    const cleanFilter = input.dataset.cleanfilter;
                    if (!cleanFilter || cleanFilter !== 'no') {
                        input.value = '';
                        input.checked = false;
                    }
                });
                this.reloadManager.reloadModule(form, undefined, true);
            });
        });
    }

    private registerEventListenersForFields(viewRoot: HTMLElement) {
        // Event-Listener fuer `change` auf `select`- und `input`-Elementen mit der Klasse `cmsReloadModule`  (z.b. der Preisslider ist ein Change)
        viewRoot.querySelectorAll('select.cmsReloadModule, input.cmsReloadModule').forEach((element) => {
            element.addEventListener('change', (event) => {
                this.reloadManager.cmsReloadModule(event);
            });
        });

        // Event-Listener fuer `click` auf `input`-Elementen mit der Klasse `cmsReloadModule`
        viewRoot.querySelectorAll('input.cmsReloadModule').forEach((element) => {
            element.addEventListener('click', (event) => {
                this.reloadManager.cmsReloadModule(event);
            });
        });
    }
}
